import src from "IMAGE";
export default { src, width: 540, height: 540, blurWidth: 0, blurHeight: 0};
